import { render, staticRenderFns } from "./DiagnosisPlanEdit.vue?vue&type=template&id=8536dea6&scoped=true&"
import script from "./DiagnosisPlanEdit.vue?vue&type=script&lang=js&"
export * from "./DiagnosisPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8536dea6",
  null
  
)

export default component.exports